module.exports = __webpack_public_path__ + "img/resource04.1e4946d0.png";